import axios from 'axios';
import { FEEDBACK_ENDPOINT, RATING_ENDPOINT, CASES_ENDPOINT } from '../constants/endpoint';

const CreateFeedback = async (contactId, feedback, rating, faqTitle) => {
  try {
    const { data } = await axios.post(`${FEEDBACK_ENDPOINT}/${contactId}?rating=${rating}`, { feedback, faqTitle });
    return data;
  } catch (err) {
    const message = err.response?.data?.message;
    throw message || err;
  }
};

const CreateRating = async (contactId, rating) => {
  try {
    const { data } = await axios.post(`${RATING_ENDPOINT}/${contactId}?rating=${rating}`);
    return data;
  } catch (err) {
    const message = err.response?.data?.message;
    throw message || err;
  }
};

const GetRating = async contactId => {
  try {
    const { data } = await axios.get(`${RATING_ENDPOINT}/${contactId}`);
    return data;
  } catch (err) {
    const message = err.response?.data?.message;
    throw message || err;
  }
};

const CreateSupportCase = async (prospectId, emailBody) => {
  try {
    const { data } = await axios.post(`${CASES_ENDPOINT}/${prospectId}`, { ...emailBody, origin: 'mySunrun' });
    return data;
  } catch (err) {
    const message = err.response?.data?.message;
    throw message || err;
  }
};

export { CreateFeedback, CreateRating, CreateSupportCase, GetRating };
